import API_URL from '../config';

// ── AUTH ──
export const loginUsuario = async (email, password) => {
  const res = await fetch(`${API_URL}/api/usuarios/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password }),
  });
  return res.json();
};

export const registrarUsuario = async (datos) => {
  const res = await fetch(`${API_URL}/api/usuarios/registro`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(datos),
  });
  return res.json();
};



// ── EQUIPOS ──
export const getEquipos = async () => {
  const res = await fetch(`${API_URL}/api/equipos`);
  return res.json();
};

export const actualizarEquipo = async (id, datos, token) => {
  const res = await fetch(`${API_URL}/api/equipos/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify(datos),
  });
  return res.json();
};


export const getEquipo = async (urlNombre) => {
  const res = await fetch(`${API_URL}/api/equipos/${urlNombre}`);
  return res.json();
};

export const crearEquipo = async (datos, token) => {
  const res = await fetch(`${API_URL}/api/equipos`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify(datos),
  });
  return res.json();
};

export const actualizarElo = async (id, elo, token) => {
  const res = await fetch(`${API_URL}/api/equipos/${id}/elo`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify({ elo }),
  });
  return res.json();
};

// ── JUGADORES ──
export const getJugadores = async (equipoId) => {
  const res = await fetch(`${API_URL}/api/jugadores/equipo/${equipoId}`);
  return res.json();
};

export const agregarJugador = async (datos, token) => {
  const res = await fetch(`${API_URL}/api/jugadores`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify(datos),
  });
  return res.json();
};

export const eliminarJugador = async (id, token) => {
  const res = await fetch(`${API_URL}/api/jugadores/${id}`, {
    method: 'DELETE',
    headers: { 'Authorization': `Bearer ${token}` },
  });
  return res.json();
};

// ── RECINTOS ──
export const getRecintos = async () => {
  const res = await fetch(`${API_URL}/api/recintos`);
  return res.json();
};

export const crearRecinto = async (datos, token) => {
  const res = await fetch(`${API_URL}/api/recintos`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify(datos),
  });
  return res.json();
};

// ── ÁRBITROS ──
export const getArbitros = async () => {
  const res = await fetch(`${API_URL}/api/arbitros`);
  return res.json();
};

export const crearArbitro = async (datos) => {
  const res = await fetch(`${API_URL}/api/arbitros`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(datos),
  });
  return res.json();
};

export const crearTercerTiempo = async (datos) => {
  const res = await fetch(`${API_URL}/api/tercer-tiempo`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(datos),
  });
  return res.json();
};
// ── DESAFÍOS ──
export const getDesafiosEquipo = async (equipoId, token) => {
  const res = await fetch(`${API_URL}/api/desafios/equipo/${equipoId}`, {
    headers: { 'Authorization': `Bearer ${token}` },
  });
  return res.json();
};

export const crearDesafio = async (datos, token) => {
  const res = await fetch(`${API_URL}/api/desafios`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify(datos),
  });
  return res.json();
};

export const actualizarEstadoDesafio = async (id, estado, token) => {
  const res = await fetch(`${API_URL}/api/desafios/${id}/estado`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify({ estado }),
  });
  return res.json();
};

// ── PARTIDOS ──
export const getPartidosEquipo = async (equipoId, token) => {
  const res = await fetch(`${API_URL}/api/partidos/equipo/${equipoId}`, {
    headers: { 'Authorization': `Bearer ${token}` },
  });
  return res.json();
};

export const registrarPartido = async (datos, token) => {
  const res = await fetch(`${API_URL}/api/partidos`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify(datos),
  });
  return res.json();
};

// ── EVALUACIONES ──
export const getEvaluacionesEquipo = async (equipoId, token) => {
  const res = await fetch(`${API_URL}/api/evaluaciones/equipo/${equipoId}`, {
    headers: { 'Authorization': `Bearer ${token}` },
  });
  return res.json();
};

export const crearEvaluacion = async (datos, token) => {
  const res = await fetch(`${API_URL}/api/evaluaciones`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify(datos),
  });
  return res.json();
};

export const verificarEvaluacion = async (partidoId, equipoOrigenId) => {
  const res = await fetch(`${API_URL}/api/evaluaciones/verificar/${partidoId}/${equipoOrigenId}`);
  return res.json();
};

export const eliminarEquipo = async (id, token) => {
  const res = await fetch(`${API_URL}/api/equipos/${id}`, {
    method: 'DELETE',
    headers: { 'Authorization': `Bearer ${token}` },
  });
  return res.json();
};

export const registrarRecinto = async (datos) => {
  const res = await fetch(`${API_URL}/api/recintos`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(datos),
  });
  return res.json();
};

export const registrarCancha = async (datos) => {
  const res = await fetch(`${API_URL}/api/canchas`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(datos),
  });
  return res.json();
};

export const eliminarCancha = async (id) => {
  const res = await fetch(`${API_URL}/api/canchas/${id}`, {
    method: 'DELETE',
  });
  return res.json();
};

// ── KHIPU (PAGOS) ──
export const crearCobroDesafio = async (desafioId, token) => {
  const res = await fetch(`${API_URL}/api/khipu/crear-cobro/${desafioId}`, {
    method: 'POST',
    headers: { 'Authorization': `Bearer ${token}` },
  });
  return res.json();
};

export const getEstadoPago = async (desafioId) => {
  const res = await fetch(`${API_URL}/api/khipu/estado/${desafioId}`);
  return res.json();
};
